var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog",
      attrs: { title: "切换规格", visible: _vm.visibleSync, width: "800px" },
      on: {
        "update:visible": function($event) {
          _vm.visibleSync = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "f15 gray3 mar10-b flex" },
            [
              _c("div", { staticClass: "fb" }, [_vm._v("商品：")]),
              _c("div", { staticClass: "pad20-r" }, [
                _vm._v(_vm._s(_vm.goods.skuName))
              ]),
              _vm.activityName
                ? [
                    _c("div", { staticClass: "fb" }, [_vm._v("活动：")]),
                    _c("div", [_vm._v(_vm._s(_vm.activityName))])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._l(_vm.specialList, function(item, index) {
            return [
              _c("div", { key: "a" + index, staticClass: "pad10-t pad10-b" }, [
                _vm._v(_vm._s(item.specType))
              ]),
              _c(
                "div",
                {
                  key: "b" + index,
                  staticClass: "flex text-center nowrap flex-wrap"
                },
                _vm._l(item.specValList, function(spec, specIndex) {
                  return _c(
                    "div",
                    {
                      key: specIndex,
                      staticClass:
                        "radius5 mar10-r mar10-b pad5-tb pad10-lr pointer item",
                      class: { active: spec == _vm.skuSpecsList[index] },
                      on: {
                        click: function($event) {
                          return _vm.skuSpecsChange(index, spec)
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(spec) + "\n        ")]
                  )
                }),
                0
              )
            ]
          }),
          _c("div", { staticClass: "flex f16 mar10-t justify-end" }, [
            _c("div", { staticClass: "fb" }, [_vm._v("价格：")]),
            _vm.goodsTem.currPrice || _vm.goodsTem.originalPrice
              ? _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.goodsTem.currPrice || _vm.goodsTem.originalPrice
                    ) + "元"
                  )
                ])
              : _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goUrl(
                          "reserve/add.do?goodsId=" + _vm.goods.skuId
                        )
                      }
                    }
                  },
                  [_vm._v("点击询价")]
                )
          ]),
          _c(
            "div",
            { staticClass: "text-center pad20-b pad30-t" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function($event) {
                      _vm.visibleSync = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "mar20-l",
                  attrs: { size: "medium", type: "primary" },
                  on: { click: _vm.skuSpecsChangeConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }